import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import home from '@m2h/assets/img/c_tab_bar/home@2x.png';
import home_active from '@m2h/assets/img/c_tab_bar/home_active@2x.png';
// import home_active_top from '@m2h/assets/img/c_tab_bar/home_active_top@2x.png';
import order from '@m2h/assets/img/c_tab_bar/order@2x.png';
import order_active from '@m2h/assets/img/c_tab_bar/order_active@2x.png';
import profile from '@m2h/assets/img/c_tab_bar/profile@2x.png';
import profile_active from '@m2h/assets/img/c_tab_bar/profile_active@2x.png';
import { toLogin } from '@m2h/common/utils';
import { useTranslation } from '@sailor/i18n-web';
import './index.css';

interface BottomNavigationProps {}

const BottomNavigation: React.FC<BottomNavigationProps> = (props: BottomNavigationProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  // console.log('BottomNavigation');
  const marginBottomHeight = Mach.env?.safeAreaInsets?.bottom || 16;

  const onBtnClick = (params: { path: string; checkLogin?: boolean; }) => {
    const { path, checkLogin = false } = params;
    if (checkLogin) {
      const Login = Mach.requireModule('Login');
      const isLogin = Login.isLogin();
      if (!isLogin) return toLogin();
    }
    navigate(path);
  };

  const [activeTab, setActiveTab] = useState(0);

  const getTabIndexByPath = (path: string): number => {
    if (['/mpweb/home_page_main', '/mpweb/home_page_main/', '/mpweb', '/mpweb/', '/'].includes(path)) {
      return 0;
    }
    if (['/mpweb/order_list', '/mpweb/order_list/'].includes(path)) {
      return 1;
    }
    if (['/mpweb/mine', '/mpweb/mine/'].includes(path)) {
      return 2;
    }
    return -1; // 默认返回值，表示未匹配的路径
  };

  useEffect(() => {
    const tabValue = getTabIndexByPath(location.pathname);
    tabValue !== -1 && setActiveTab(tabValue);
  }, []);

  return (
    <view className="bottom-navi-container">
      <view className="navi-buttons">
        {/* 首页滑动到一定位置后，图标&文字变成关东到顶部 */}
        <view className="icon-button" onClick={() => onBtnClick({ path: '/mpweb/home_page_main' })}>
          <view className="button-img">
            {/*<image className="btn-img" src="assets://shop/icon_arrow_right_bold_golden.png" />*/}
            <img className="btn-img" src={activeTab === 0 ? home_active : home} />
          </view>
          <text className="button-text">{t('shou_bottom_tab1')}</text>
        </view>

        <view className="icon-button" onClick={() => onBtnClick({ path: '/mpweb/order_list', checkLogin: true })}>
          <view className="button-img">
            <img className="btn-img" src={activeTab === 1 ? order_active : order} />
          </view>
          <text className="button-text">{t('shou_bottom_tab3')}</text>
        </view>

        <view className="icon-button" onClick={() => onBtnClick({ path: '/mpweb/mine' })}>
          <view className="button-img">
            <img className="btn-img" src={activeTab === 2 ? profile_active : profile} />
          </view>
          <text className="button-text">{t('shou_bottom_tab4')}</text>
        </view>
      </view>
      <view className="margin-bottom" style={{ height: marginBottomHeight }} />
    </view>
  );
};

export default BottomNavigation;
